import i18n from '@shared/config/i18n';

const { t } = i18n;

export const data = [
  { id: 0, title: t('Frees') },
  { id: 1, title: t('Paids') },
];
